import html from "../img/html.png";
import css from "../img/css.png";
import javascript from "../img/javascript.png";
import react from "../img/react.png";
import tailwind from "../img/tailwind.png";
import github from "../img/github.png";
import XD from "../img/xd.png";
import livewire from "../img/livewire.svg";
import nextjs from "../img/nextjs.svg";
import figma from "../img/figma-1.svg";
import Mui from "../img/material.png";

const skills = [
  {
    title: "HTML",
    href: "https://developer.mozilla.org/en-US/docs/Web/HTML",
    icon: html,
    description:
      "Good knowledge in html along with semantic tags and some SEO optimizing things around 1.6yr professional exp with html.",
    id: 1,
    rating: "9/10",
  },
  {
    title: "CSS",
    href: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    icon: css,
    description:
      "Mainly working with TailwindCss because it is best for headless ui's but my core css skills is also greate to create nice ui's. Proeficient in creating responsive designs by grid and flexboxes.",
    id: 2,
    rating: "8/10",
  },
  {
    title: "JavaScript",
    href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    icon: javascript,
    description:
      "Not expert in javascript but yes more than basic skills in that to create well balanced responsive ui and have sufficient knowledge in es6 as well.",
    id: 3,
    rating: "8/10",
  },
  {
    title: "React",
    href: "https://beta.reactjs.org/",
    icon: react,
    description:
      "As an entry-level frontend dev more than basic skills in react mainly working knowledge on functional components with hooks and did some projects and clones for practice as well. Using knowledge of various libraries like react-scroll,parallax and other things.Still gainnign skills in react because not to profiecient in this.",
    id: 4,
    rating: "8/10",
  },
  {
    title: "TailwindCss",
    href: "https://tailwindcss.com/",
    icon: tailwind,
    description:
      "Not expert but yes near to advanced scale knowldge in tailwind in creating responsive desings as this portfolio created in tailwind also and full responsive. Have knowledge of animation, transition, flexboxes, grid system, etc. Still developing skills with this and gainning some remmaining knowledge.",
    id: 5,
    rating: "8/10",
  },
  {
    title: "Next.js",
    href: "https://nextjs.org/",
    icon: nextjs,
    description:
      "Mainly Working on next.js for development created a simple blog site as side project and worked on some marketplace sites in next.js as well.",
    id: 6,
    rating: "8/10",
  },
  {
    title: "Github",
    href: "https://docs.github.com/en",
    icon: github,
    description:
      "Some basic and necessary knowledge in github like push,pull and clone and many other necessary skills.",
    id: 7,
    rating: "7/10",
  },
  {
    title: "Figma",
    href: "https://www.figma.com/best-practices/guide-to-developer-handoff/components-styles-and-documentation/",
    icon: figma,
    description:
      "I know some basic prototyping/Wireframing through figma as well. So that help in designing things. Studied it briefly in meta frontend development certification and google ux design certification.",
    id: 8,
    rating: "7/10",
  },
  {
    title: "LiveWire",
    href: "https://laravel-livewire.com/",
    icon: livewire,
    description:
      "Advance knowledge livewire component based laravel frontend library i used it with alpine and tailwind and created a large website ui by this present on github.",
    id: 9,
    rating: "8/10",
  },
  {
    title: "Material Ui",
    href: "https://mui.com/",
    icon: Mui,
    description:
      "As mainly working as frontend dev so used material ui in some projects as well so have its sufficient knowledge to use its compnent efficiently and work with it easily.",
    id: 10,
    rating: "7/10",
  },
  {
    title: "Adobe XD",
    href: "https://helpx.adobe.com/support/xd.html",
    icon: XD,
    description:
      "I know some basic prototyping/Wireframing through Adobe XD as well. So that help in designing things. Completed some certifictions for it as well and some case studies also present here.",
    id: 11,
    rating: "7/10",
  },
];
export { skills };
